/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_6_QInputs */

const en_cp_faq_6_q = /** @type {(inputs: Cp_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does Campus Lead differ from GDG on Campus or a Claude Builder Club?`)
};

const id_cp_faq_6_q = /** @type {(inputs: Cp_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa bedanya Campus Lead dengan GDG on Campus atau Claude Builder Club?`)
};

/**
* | output |
* | --- |
* | "How does Campus Lead differ from GDG on Campus or a Claude Builder Club?" |
*
* @param {Cp_Faq_6_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_6_q = /** @type {((inputs?: Cp_Faq_6_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_6_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_6_q(inputs)
	return en_cp_faq_6_q(inputs)
});